import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
};
export type DeleteReservationResponse = {
  data: Reservation;
};

export const useDeleteReservation = createMutation<
  DeleteReservationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/reservations/${variables.id}`,
      method: 'DELETE',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
